
export default function LoadingSpinner() {
	return (
		<div style={{}}>
			<img src="/loading.gif" alt={"Loading..."} style={{ width: "100px", height: "100px", margin: "10em auto", display: "block" }} />
		</div>
	);
}
